import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { Card, Form, Button } from "react-bootstrap";
// import { MdCategory, FaStethoscope, FaSave } from "react-icons/all";

import { FaStethoscope, FaSave } from "react-icons/fa";
import { MdCategory } from "react-icons/md";

import "./PatientDiagnosisUpdateModal.css";

const PatientDiagnosisUpdateModal = ({
  currentRecord,
  handleDiagnosisUpdate,
}) => {
  const [diagnosesData, setDiagnosesData] = useState([]);
  const [diagnosisDataOptions, setDiagnosisDataOptions] = useState([]);
  const [diagnosisCategory, setDiagnosisCategory] = useState([]);
  const [formData, setFormData] = useState({
    category_id: currentRecord?.diagnoses?.category_id,
    diagnosis_id: currentRecord?.diagnoses?.diagnosis_id,
    diagnosis_code: currentRecord?.diagnoses?.diagnosis_code,
    diagnosis_name: currentRecord?.diagnoses?.diagnosis_name,
    notes: null,
    patient_id: currentRecord?._id,
  });

  // Add new state for validation
  const [validated, setValidated] = useState(false);

  // Add custom styles for react-select
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      borderColor: state.isFocused ? "#2684FF" : "#e2e8f0",
      boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : null,
      borderRadius: "0.375rem",
      minHeight: "42px",
      "&:hover": {
        borderColor: state.isFocused ? "#2684FF" : "#cbd5e0",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#2684FF"
        : state.isFocused
        ? "#deebff"
        : "white",
      color: state.isSelected ? "white" : "black",
      padding: "8px 12px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#a0aec0",
    }),
  };

  //Get Diagnosis Category Based on State
  useEffect(() => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    let urlLink = `${process.env.REACT_APP_API_URL}/dcat/state/${currentRecord?.tc_state}`;

    axios
      .get(urlLink, config)
      .then((res) => {
        const responseData = res?.data?.categories;
        //console.log(responseData);
        const diagnosesCatData = responseData.map((c) => ({
          value: c._id,
          label: c.category,
        }));
        setDiagnosisCategory(diagnosesCatData);
      })
      .catch((err) => console.log("error", err));
  }, [currentRecord?.tc_state]);

  // Getting Diagnosis from server
  useEffect(() => {
    const getDataFromServer = () => {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };

      let urlLink = `${process.env.REACT_APP_API_URL}/diagnosis/`;

      axios
        .get(urlLink, config)
        .then((res) => {
          const olDdiagnosesData = res.data.diagnoses;
          // console.log(olDdiagnosesData);
          const res_diagnosesData = olDdiagnosesData.map((d) => ({
            _id: d._id,
            value: d._id,
            label: d.label,
            diagnosis_code: d.id,
            diagnosis_name: d.diagnosis_name,
            cat_name: d?.category_id?.category,
            category_id: d?.category_id?._id,
          }));

          setDiagnosesData(res_diagnosesData);

          // If we have current diagnosis, set the diagnosis options
          if (currentRecord?.diagnoses?.category_id) {
            const filteredDiagnoses = res_diagnosesData.filter(
              (diag) => diag.category_id === currentRecord.diagnoses.category_id
            );
            setDiagnosisDataOptions(filteredDiagnoses);

            // Set initial form data with current record values
            setFormData({
              category_id: currentRecord.diagnoses.category_id,
              diagnosis_id: currentRecord.diagnoses.diagnosis_id,
              diagnosis_name: currentRecord.diagnoses.diagnosis_name,
              diagnosis_code: currentRecord.diagnoses.diagnosis_code,
              patient_id: currentRecord?._id,
            });
          }
        })
        .catch((err) => console.log("error", err));
    };

    getDataFromServer();
  }, [currentRecord?.diagnoses]);

  useEffect(() => {
    if (formData?.category_id) {
      const filteredOptions = diagnosesData.filter(
        (diag) => diag.category_id === formData.category_id
      );
      setDiagnosisDataOptions(filteredOptions);
    }
  }, [formData?.category_id, diagnosesData]);

  const handleSubmit = () => {
    // Add validation check
    if (!formData.notes) {
      setValidated(true);
      return;
    }

    let userToken = localStorage.getItem("token");
    let urlLink = `${process.env.REACT_APP_API_URL}/patient/update/diagnosis/${currentRecord?._id}`;

    const config = {
      method: "POST",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { ...formData },
    };

    axios(config)
      .then((res) => {
        handleDiagnosisUpdate(formData);
      })
      .catch((err) => console.log("error", err));
    // console.log("Submitting form data:", formData);
  };

  return (
    <Card className="p-4">
      <Form noValidate validated={validated}>
        <Form.Group className="mb-3">
          <div className="d-flex align-items-center mb-2">
            <MdCategory className="me-2 text-secondary" size={20} />
            <Form.Label className="fw-bold">Diagnosis Category</Form.Label>
          </div>
          <Select
            name="category_id"
            onChange={(selected) => {
              setFormData({
                ...formData,
                category_id: selected.value,
                diagnosis_id: null,
                diagnosis_name: null,
                diagnosis_code: null,
              });
            }}
            options={diagnosisCategory}
            styles={customStyles}
            value={
              formData.category_id
                ? diagnosisCategory.find(
                    (cat) => cat.value === formData.category_id
                  )
                : null
            }
            placeholder="Select category..."
            classNamePrefix="react-select"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <div className="d-flex align-items-center mb-2">
            <FaStethoscope className="me-2 text-secondary" size={18} />
            <Form.Label className="fw-bold">Diagnosis Name</Form.Label>
          </div>
          <Select
            name="diagnosis_id"
            onChange={(selected) => {
              setFormData({
                ...formData,
                diagnosis_id: selected.value,
                diagnosis_name: selected.label,
                diagnosis_code: selected.diagnosis_code,
              });
            }}
            options={diagnosisDataOptions}
            styles={customStyles}
            value={
              formData.diagnosis_id
                ? diagnosisDataOptions.find(
                    (diag) => diag.value === formData.diagnosis_id
                  )
                : null
            }
            isDisabled={!formData.category_id}
            placeholder="Select diagnosis..."
            classNamePrefix="react-select"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <div className="d-flex align-items-center mb-2">
            <FaStethoscope className="me-2 text-secondary" size={20} />
            <Form.Label className="fw-bold">Notes</Form.Label>
          </div>
          <Form.Control
            as="textarea"
            rows={3}
            name="notes"
            value={formData.notes || ""}
            onChange={(e) =>
              setFormData({ ...formData, notes: e.target.value })
            }
            placeholder="Enter notes..."
            required
            isInvalid={validated && !formData.notes}
          />
          <Form.Control.Feedback type="invalid">
            Please enter notes before saving changes.
          </Form.Control.Feedback>
        </Form.Group>

        <div className="d-flex justify-content-end">
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={!formData.notes}
          >
            <FaSave className="me-2" /> Save Changes
          </Button>
        </div>
      </Form>
    </Card>
  );
};

export default PatientDiagnosisUpdateModal;
